var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionManageSecret(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17.763,
    viewBox: "0 0 14 17.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_672_5",
    "data-name": "Component 672 \\u2013 5",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9549",
    "data-name": "Group 9549",
    transform: "translate(1.333 0.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M11,16.763H2a2,2,0,0,1-2-2V8.129a2,2,0,0,1,2-2h.538v.006h7.926V6.129H11a2,2,0,0,1,2,2v6.634A2,2,0,0,1,11,16.763ZM10.464,6.13H2.538V3.317a3.167,3.167,0,0,1,.778-2.2A4.142,4.142,0,0,1,6.5,0,4.143,4.143,0,0,1,9.686,1.117a3.164,3.164,0,0,1,.778,2.2V6.129Z",
    transform: "translate(-1.333 -0.685)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9547",
    "data-name": "Group 9547",
    transform: "translate(4.36 7.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_492",
    "data-name": "Ellipse 492",
    transform: "translate(-0.443 1)",
    fill: "#fff",
    stroke: "#4d4d4d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.25,
    cy: 1.25,
    r: 0.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13665",
    "data-name": "Path 13665",
    d: "M10453,7700v2.192",
    transform: "translate(-10452.192 -7697.596)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionManageSecret);
export default __webpack_public_path__ + "static/media/action_manage_secret.c3227a361eaeb1dad6adbe853d7b8fe7.svg";
export { ForwardRef as ReactComponent };